import {FONT_COLOR, FONT_VARIANT} from "../../../../../components/fonts/font-props";
import FontBody2 from "../../../../../components/fonts/font-body2/font-body2";
import React from "react";
import WalletTransactionStore from "../../../stores/wallet/wallet-transaction-store";
import Currency from "../../../../../components/currency/currency";
import { WALLET_TRANSACTION_ENUM, WALLET_TRANSACTION_STATUS_ENUM } from "../../../../../services/api/wallet-service";

interface ITransactionAmountProps {
    transaction: WalletTransactionStore
}

const getColor = (transaction: WalletTransactionStore) => {
    let color = FONT_COLOR.PRIMARY3;

    if (transaction.status === WALLET_TRANSACTION_STATUS_ENUM.STATUS_SUCCEEDED) {
        if ([
                WALLET_TRANSACTION_ENUM.TYPE_WITHDRAWAL,
                WALLET_TRANSACTION_ENUM.TYPE_DEBT,
                WALLET_TRANSACTION_ENUM.TYPE_ADMIN_WITHDRAWAL,
            ].includes(transaction.type)
        ) {
            color = FONT_COLOR.ACCENT3; // RED
        }
        else if (transaction.isDeposit) {
            color = FONT_COLOR.PRIMARY1; // GREEN
        }
    }
    else if (transaction.status === WALLET_TRANSACTION_STATUS_ENUM.STATUS_PENDING) {
        color = FONT_COLOR.ACCENT4; // YELLOW
    }

    return color;
}

const TransactionAmount: React.FC<ITransactionAmountProps> = ({ transaction }) => {
    return (
        <FontBody2
            variant={FONT_VARIANT.DEFAULT}
            color={getColor(transaction)}
        >
            <Currency
                amount={transaction.isDeposit ? Number(transaction.amount) : Number(transaction.amount) * -1}
                currencyCode={transaction.currency}
                useNative={true}
            />
        </FontBody2>
    )
};

export default TransactionAmount;